import React from 'react';
import { RefreshCw } from 'lucide-react';

const TelegramRequiredScreen = () => {
  // Cette fonction permet de rafraîchir la page
  const handleReload = () => {
    window.location.reload();
  };

  // Détecte si l'utilisateur est sur mobile
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return (
    <div className="fixed inset-0 bg-white flex flex-col items-center justify-center p-6 z-50">
      <div className="bg-blue-50 border border-blue-100 rounded-full p-6 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" className="text-blue-500">
          <path d="M22 43C33.598 43 43 33.598 43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10.9 22.5L18.2 29.8L33.1 14.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      <h1 className="text-2xl font-bold text-gray-900 mb-3 text-center">Veuillez ouvrir dans Telegram</h1>
      
      <p className="text-center text-gray-600 mb-8 max-w-md">
        Cette application est conçue pour fonctionner uniquement dans l'application Telegram. 
        Veuillez l'ouvrir depuis Telegram pour continuer.
      </p>

      <div className="mb-6 space-y-4 w-full max-w-xs">
        <button onClick={handleReload} className="w-full flex items-center justify-center gap-2 bg-blue-500 text-white py-3 px-6 rounded-xl font-medium">
          <RefreshCw size={20} />
          Rafraîchir la page
        </button>
        
        {isMobileDevice ? (
          <p className="text-center text-gray-500 text-sm mt-4">
            Si vous avez déjà Telegram, veuillez y accéder et chercher "@KappelavendeurBot".
          </p>
        ) : (
          <p className="text-center text-gray-500 text-sm mt-4">
            Ouvrez l'application Telegram et recherchez "@KappelavendeurBot".
          </p>
        )}
      </div>
    </div>
  );
};

export default TelegramRequiredScreen;